import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { verifyOrderPayment } from "../api"; // adjust path to your API file
import { renderErrorMessage, renderSuccessMessage } from "src/assets/functions";

const ConfirmOrderPage = () => {
    const [searchParams] = useSearchParams();
    const trxref = searchParams.get("trxref");

    const [isSuccess, setIsSuccess] = useState(null); // starts as null (no result yet)

    const { mutate, isLoading } = useMutation({
        mutationFn: verifyOrderPayment,
        onSuccess: (data) => {
            renderSuccessMessage(data.message);
            setIsSuccess(true);
        },
        onError: (error) => {
            renderErrorMessage(error.message);
            setIsSuccess(false);
        },
    });

    useEffect(() => {
        if (trxref) {
            mutate(trxref); // pass trxref directly
        }
    }, [trxref]);

    return (
        <div className="p-8 rounded shadow-md bg-white text-center">
            {isSuccess === null ? (
                <p>Checking your order...</p>
            ) : isSuccess ? (
                <>
                    <h1 className="text-2xl font-bold text-green-600 mb-4">🎉 Order Successful!</h1>
                    <p className="text-gray-700 mb-[50px]">Thank you for your purchase. You’ll receive an email confirmation shortly.</p>
                    <a href="/account" className="check-orders-btn ">Check Orders</a>
                </>
            ) : (
                <>
                    <h1 className="text-2xl font-bold text-red-600 mb-4">❌ Order Failed</h1>
                    <p className="text-gray-700">Something went wrong. Please try again or contact support.</p>
                </>
            )}
        </div>
    );
};

export default ConfirmOrderPage;
